// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"3d780163","41":"c0c36f34","316":"7875257e","463":"5866cdb8","639":"3d780163","850":"9489d17a"}[chunkId] + ".chunk.css";
};